import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import type { Query } from "@tanstack/react-query";
import { kvStorage } from "../offline/db";

/**
 * Gegevens op dit apparaat bewaren (SPEC §11): gebouwen waar je mee bezig bent (structuur, open
 * bevindingen, details, taken) blijven zonder verbinding beschikbaar. Tekeningen en foto's bewaart
 * de service worker. Bij uitloggen wordt alles gewist.
 */
export const CACHE_MAX_AGE = 7 * 24 * 3600 * 1000;
const PERSISTED = new Set([
  "me",
  "buildings",
  "building",
  "issues",
  "issue",
  "tasks",
  "my-tasks",
  "asset",
  // Conditiemeting in het veld (docs/CONDITIEMETING.md §10.2): ook zonder bereik verder kunnen.
  "condition-assessment",
  // Meterstanden opnemen (docs/METERSTANDEN.md §8): ook zonder bereik verder kunnen.
  "meter-round",
]);

export const persister = createAsyncStoragePersister({ storage: kvStorage, key: "pw-query-cache", throttleTime: 1000 });

export const persistOptions = {
  persister,
  maxAge: CACHE_MAX_AGE,
  // Andere vorm van de gegevens = oude cache weggooien.
  buster: "m10",
  dehydrateOptions: {
    // Niet ingelogd (me = null) niet bewaren: anders lijkt je na het inloggen nog uitgelogd.
    // Wel bewaren als opnieuw ophalen mislukte (status "error", oude gegevens nog aanwezig): zonder
    // verbinding mislukt elke refetch, en dan zou het gebouw bij de volgende keer opslaan wegvallen.
    shouldDehydrateQuery: (q: Query) => q.state.data != null && PERSISTED.has(String(q.queryKey[0])),
  },
};
